import { Card } from '@zorro/design-system/v2/Card';
import { IconZorroBulb } from '@zorro/shared/assets';
import { Flex, Stack, Text } from '@zorro/web/design-system';

const PaymentMethodNotice = () => {
  return (
    <Card px="md" py="lg" variant="grey">
      <Flex columnGap="xs" align="flex-start" wrap="nowrap">
        <IconZorroBulb />
        <Stack>
          <Text size="sm">
            This payment method is set up for your healthcare premiums, funded
            by your employer. It covers both your allowance and any
            self-contributions. Please use it exclusively for premium payments
            to your carrier
          </Text>
        </Stack>
      </Flex>
    </Card>
  );
};

export { PaymentMethodNotice };
